var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOurSafeLegal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "89px",
    height: "89px",
    viewBox: "0 0 89 89",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, " our-safe-legal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.2412 15.6767 0.2412 15.6767 8.0792 0 8.0792"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0.1642 0.2412 15.84 0.2412 15.84 8.0792 0.1642 8.0792"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "-our-safe-legal",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(21.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3959,37.5645 L36.3459,37.5645",
    id: "Stroke-1",
    stroke: "#FFFFFF",
    strokeWidth: 4.223,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8383,1.1114 L40.0023,1.1114",
    id: "Stroke-3",
    stroke: "#FFFFFF",
    strokeWidth: 4.223,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8676,39.6729 L23.8676,39.6729 C21.7186,39.6729 19.9776,37.9289 19.9815931,35.7799 L21.8966,8.7729 C21.9006,6.6249 23.9236,4.8869 23.9236,4.8869 C23.9236,4.8869 25.9486,6.6309 25.9446,8.7789 L27.7596,35.7869 C27.7556,37.9349 26.0146,39.6729 23.8676,39.6729",
    id: "Fill-5",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(0.000000, 17.675800)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6767,0.2412 C15.6767,4.5742 12.1707,8.0792 7.8387,8.0792 C3.5117,8.0792 -0.0003,4.5742 -0.0003,0.2412 L15.6767,0.2412 Z",
    id: "Fill-7",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.8383,1.7608 L0.0003,17.9168 L15.6763,17.9168 L7.8383,1.7608 Z M7.8383,4.6088 L13.6923,16.6738 L1.9843,16.6738 L7.8383,4.6088 Z",
    id: "Fill-10",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(32.000000, 17.675800)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8402,0.2412 C15.8402,4.5742 12.3342,8.0792 8.0022,8.0792 C3.6752,8.0792 0.1642,4.5742 0.1642,0.2412 L15.8402,0.2412 Z",
    id: "Fill-12",
    fill: "#FCBC00",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.0019,1.7608 L32.1639,17.9168 L47.8399,17.9168 L40.0019,1.7608 Z M40.0019,4.6088 L45.8559,16.6738 L34.1489,16.6738 L40.0019,4.6088 Z",
    id: "Fill-15",
    fill: "#FCBC00"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurSafeLegal);
export default __webpack_public_path__ + "static/media/our-safe-legal.930a8d9f793385d6cba204a0054a1563.svg";
export { ForwardRef as ReactComponent };